/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
export class DataAssistantUX {

    key: string;
    name: string;
    description: string;
    complete: boolean;

} 